/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddressDto } from '../models/work-address-dto';
import { WorkCoordinatesDto } from '../models/work-coordinates-dto';
import { WorkCreateProjectDto } from '../models/work-create-project-dto';
import { WorkEivCalculationsDto } from '../models/work-eiv-calculations-dto';
import { WorkLinkProjectDto } from '../models/work-link-project-dto';
import { WorkLocation } from '../models/work-location';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkProject } from '../models/work-project';
import { WorkProjectAnalysisDto } from '../models/work-project-analysis-dto';
import { WorkProjectAnalysisSourceEnum } from '../models/work-project-analysis-source-enum';
import { WorkProjectDatenbereinigungPaginatedDto } from '../models/work-project-datenbereinigung-paginated-dto';
import { WorkProjectFoerderungUsedItemsWithAmountDto } from '../models/work-project-foerderung-used-items-with-amount-dto';
import { WorkProjectMapDto } from '../models/work-project-map-dto';
import { WorkProjectModulesAreaDto } from '../models/work-project-modules-area-dto';
import { WorkProjectMontagedatenVertauschtPaginatedDto } from '../models/work-project-montagedaten-vertauscht-paginated-dto';
import { WorkProjectNachfassenPaginatedDto } from '../models/work-project-nachfassen-paginated-dto';
import { WorkProjectOhneGebautDatumPaginatedDto } from '../models/work-project-ohne-gebaut-datum-paginated-dto';
import { WorkProjectOhneInbetriebnahmeDatumPaginatedDto } from '../models/work-project-ohne-inbetriebnahme-datum-paginated-dto';
import { WorkProjectPlanningModeCandidatesDto } from '../models/work-project-planning-mode-candidates-dto';
import { WorkProjectPowerWrAcDto } from '../models/work-project-power-wr-ac-dto';
import { WorkProjectStatisticsDto } from '../models/work-project-statistics-dto';
import { WorkProjectStornoPreviewDto } from '../models/work-project-storno-preview-dto';
import { WorkProjectStornoResultDto } from '../models/work-project-storno-result-dto';
import { WorkSetProjectToPlannedDto } from '../models/work-set-project-to-planned-dto';
import { WorkSetProjectToSoldDto } from '../models/work-set-project-to-sold-dto';
import { WorkSetProjectToStornoDto } from '../models/work-set-project-to-storno-dto';
import { WorkSetProjectToStornoV4Dto } from '../models/work-set-project-to-storno-v-4-dto';
import { WorkStartProjectPlanningDto } from '../models/work-start-project-planning-dto';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUnlinkProjectDto } from '../models/work-unlink-project-dto';
import { WorkUpdateProjectAnlageUndObjektdatenDto } from '../models/work-update-project-anlage-und-objektdaten-dto';
import { WorkUpdateProjectDto } from '../models/work-update-project-dto';
import { WorkUpdateProjectNotesDto } from '../models/work-update-project-notes-dto';

@Injectable({ providedIn: 'root' })
export class WorkProjectsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectsV2ControllerFindAllPaginated()` */
  static readonly ProjectsV2ControllerFindAllPaginatedPath = '/v2/projects';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by objectZip query param.
     *           <p>
     *              <b>Format: </b> filter.objectZip={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.objectZip=$not:$like:John Doe&filter.objectZip=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.objectZip'?: Array<string>;

    /**
     * Filter by installationStart query param.
     *           <p>
     *              <b>Format: </b> filter.installationStart={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.installationStart=$not:$like:John Doe&filter.installationStart=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$btw</li></ul>
     */
      'filter.installationStart'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by container.contactId query param.
     *           <p>
     *              <b>Format: </b> filter.container.contactId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.container.contactId=$not:$like:John Doe&filter.container.contactId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.container.contactId'?: Array<string>;

    /**
     * Filter by clientContactId query param.
     *           <p>
     *              <b>Format: </b> filter.clientContactId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.clientContactId=$not:$like:John Doe&filter.clientContactId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.clientContactId'?: Array<string>;

    /**
     * Filter by container.contact.businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.container.contact.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.container.contact.businessunitId=$not:$like:John Doe&filter.container.contact.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.container.contact.businessunitId'?: Array<string>;

    /**
     * Filter by container.containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.container.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.container.containertypeId=$not:$like:John Doe&filter.container.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.container.containertypeId'?: Array<string>;

    /**
     * Filter by container.contact.zipcode query param.
     *           <p>
     *              <b>Format: </b> filter.container.contact.zipcode={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.container.contact.zipcode=$not:$like:John Doe&filter.container.contact.zipcode=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.container.contact.zipcode'?: Array<string>;

    /**
     * Filter by status.id query param.
     *           <p>
     *              <b>Format: </b> filter.status.id={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.status.id=$not:$like:John Doe&filter.status.id=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.status.id'?: Array<string>;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Filter by tpbUserId query param.
     *           <p>
     *              <b>Format: </b> filter.tpbUserId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.tpbUserId=$not:$like:John Doe&filter.tpbUserId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.tpbUserId'?: Array<string>;

    /**
     * Filter by user.businessdivisionId query param.
     *           <p>
     *              <b>Format: </b> filter.user.businessdivisionId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.user.businessdivisionId=$not:$like:John Doe&filter.user.businessdivisionId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.user.businessdivisionId'?: Array<string>;

    /**
     * Filter by statusId query param.
     *           <p>
     *              <b>Format: </b> filter.statusId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.statusId=$not:$like:John Doe&filter.statusId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.statusId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>numberQualified</li>
     * <li>installationStart</li>
     * <li>installationEnd</li>
     * <li>sale</li>
     * <li>implementing</li>
     * <li>container.contact.lastName</li>
     * <li>objectCity</li>
     * <li>status.id</li>
     * <li>statusId</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'numberQualified:ASC' | 'numberQualified:DESC' | 'installationStart:ASC' | 'installationStart:DESC' | 'installationEnd:ASC' | 'installationEnd:DESC' | 'sale:ASC' | 'sale:DESC' | 'implementing:ASC' | 'implementing:DESC' | 'container.contact.lastName:ASC' | 'container.contact.lastName:DESC' | 'objectCity:ASC' | 'objectCity:DESC' | 'status.id:ASC' | 'status.id:DESC' | 'statusId:ASC' | 'statusId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> objectZip,objectCity,objectStreet,container.contact.zipcode,container.contact.city
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>objectZip</li>
     * <li>objectCity</li>
     * <li>objectStreet</li>
     * <li>container.contact.zipcode</li>
     * <li>container.contact.city</li>
     * <li>numberQualified</li>
     * <li>title</li>
     * <li>container.contact.lastName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProject>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'objectZip'?: (string | Array<string>);
'installationStart'?: (string | Array<string>);
'active'?: (string | Array<string>);
'container.contactId'?: (string | Array<string>);
'clientContactId'?: (string | Array<string>);
'container.contact.businessunitId'?: (string | Array<string>);
'container.containertypeId'?: (string | Array<string>);
'container.contact.zipcode'?: (string | Array<string>);
'status.id'?: (string | Array<string>);
'userId'?: (string | Array<string>);
'tpbUserId'?: (string | Array<string>);
'user.businessdivisionId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.objectZip', params['filter.objectZip'], {});
      rb.query('filter.installationStart', params['filter.installationStart'], {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.container.contactId', params['filter.container.contactId'], {});
      rb.query('filter.clientContactId', params['filter.clientContactId'], {});
      rb.query('filter.container.contact.businessunitId', params['filter.container.contact.businessunitId'], {});
      rb.query('filter.container.containertypeId', params['filter.container.containertypeId'], {});
      rb.query('filter.container.contact.zipcode', params['filter.container.contact.zipcode'], {});
      rb.query('filter.status.id', params['filter.status.id'], {});
      rb.query('filter.userId', params['filter.userId'], {});
      rb.query('filter.tpbUserId', params['filter.tpbUserId'], {});
      rb.query('filter.user.businessdivisionId', params['filter.user.businessdivisionId'], {});
      rb.query('filter.statusId', params['filter.statusId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkProject>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'objectZip'?: (string | Array<string>);
        'installationStart'?: (string | Array<string>);
        'active'?: (string | Array<string>);
        'container.contactId'?: (string | Array<string>);
        'clientContactId'?: (string | Array<string>);
        'container.contact.businessunitId'?: (string | Array<string>);
        'container.containertypeId'?: (string | Array<string>);
        'container.contact.zipcode'?: (string | Array<string>);
        'status.id'?: (string | Array<string>);
        'userId'?: (string | Array<string>);
        'tpbUserId'?: (string | Array<string>);
        'user.businessdivisionId'?: (string | Array<string>);
        'statusId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by objectZip query param.
     *           <p>
     *              <b>Format: </b> filter.objectZip={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.objectZip=$not:$like:John Doe&filter.objectZip=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.objectZip'?: Array<string>;

    /**
     * Filter by installationStart query param.
     *           <p>
     *              <b>Format: </b> filter.installationStart={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.installationStart=$not:$like:John Doe&filter.installationStart=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$btw</li></ul>
     */
      'filter.installationStart'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by container.contactId query param.
     *           <p>
     *              <b>Format: </b> filter.container.contactId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.container.contactId=$not:$like:John Doe&filter.container.contactId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.container.contactId'?: Array<string>;

    /**
     * Filter by clientContactId query param.
     *           <p>
     *              <b>Format: </b> filter.clientContactId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.clientContactId=$not:$like:John Doe&filter.clientContactId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.clientContactId'?: Array<string>;

    /**
     * Filter by container.contact.businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.container.contact.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.container.contact.businessunitId=$not:$like:John Doe&filter.container.contact.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.container.contact.businessunitId'?: Array<string>;

    /**
     * Filter by container.containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.container.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.container.containertypeId=$not:$like:John Doe&filter.container.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.container.containertypeId'?: Array<string>;

    /**
     * Filter by container.contact.zipcode query param.
     *           <p>
     *              <b>Format: </b> filter.container.contact.zipcode={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.container.contact.zipcode=$not:$like:John Doe&filter.container.contact.zipcode=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.container.contact.zipcode'?: Array<string>;

    /**
     * Filter by status.id query param.
     *           <p>
     *              <b>Format: </b> filter.status.id={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.status.id=$not:$like:John Doe&filter.status.id=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.status.id'?: Array<string>;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Filter by tpbUserId query param.
     *           <p>
     *              <b>Format: </b> filter.tpbUserId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.tpbUserId=$not:$like:John Doe&filter.tpbUserId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.tpbUserId'?: Array<string>;

    /**
     * Filter by user.businessdivisionId query param.
     *           <p>
     *              <b>Format: </b> filter.user.businessdivisionId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.user.businessdivisionId=$not:$like:John Doe&filter.user.businessdivisionId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.user.businessdivisionId'?: Array<string>;

    /**
     * Filter by statusId query param.
     *           <p>
     *              <b>Format: </b> filter.statusId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.statusId=$not:$like:John Doe&filter.statusId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.statusId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>numberQualified</li>
     * <li>installationStart</li>
     * <li>installationEnd</li>
     * <li>sale</li>
     * <li>implementing</li>
     * <li>container.contact.lastName</li>
     * <li>objectCity</li>
     * <li>status.id</li>
     * <li>statusId</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'numberQualified:ASC' | 'numberQualified:DESC' | 'installationStart:ASC' | 'installationStart:DESC' | 'installationEnd:ASC' | 'installationEnd:DESC' | 'sale:ASC' | 'sale:DESC' | 'implementing:ASC' | 'implementing:DESC' | 'container.contact.lastName:ASC' | 'container.contact.lastName:DESC' | 'objectCity:ASC' | 'objectCity:DESC' | 'status.id:ASC' | 'status.id:DESC' | 'statusId:ASC' | 'statusId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> objectZip,objectCity,objectStreet,container.contact.zipcode,container.contact.city
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>objectZip</li>
     * <li>objectCity</li>
     * <li>objectStreet</li>
     * <li>container.contact.zipcode</li>
     * <li>container.contact.city</li>
     * <li>numberQualified</li>
     * <li>title</li>
     * <li>container.contact.lastName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkProject>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'objectZip'?: (string | Array<string>);
'installationStart'?: (string | Array<string>);
'active'?: (string | Array<string>);
'container.contactId'?: (string | Array<string>);
'clientContactId'?: (string | Array<string>);
'container.contact.businessunitId'?: (string | Array<string>);
'container.containertypeId'?: (string | Array<string>);
'container.contact.zipcode'?: (string | Array<string>);
'status.id'?: (string | Array<string>);
'userId'?: (string | Array<string>);
'tpbUserId'?: (string | Array<string>);
'user.businessdivisionId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
};
};
}> {
    return this.projectsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProject>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'objectZip'?: (string | Array<string>);
'installationStart'?: (string | Array<string>);
'active'?: (string | Array<string>);
'container.contactId'?: (string | Array<string>);
'clientContactId'?: (string | Array<string>);
'container.contact.businessunitId'?: (string | Array<string>);
'container.containertypeId'?: (string | Array<string>);
'container.contact.zipcode'?: (string | Array<string>);
'status.id'?: (string | Array<string>);
'userId'?: (string | Array<string>);
'tpbUserId'?: (string | Array<string>);
'user.businessdivisionId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkProject>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'objectZip'?: (string | Array<string>);
'installationStart'?: (string | Array<string>);
'active'?: (string | Array<string>);
'container.contactId'?: (string | Array<string>);
'clientContactId'?: (string | Array<string>);
'container.contact.businessunitId'?: (string | Array<string>);
'container.containertypeId'?: (string | Array<string>);
'container.contact.zipcode'?: (string | Array<string>);
'status.id'?: (string | Array<string>);
'userId'?: (string | Array<string>);
'tpbUserId'?: (string | Array<string>);
'user.businessdivisionId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerCreate()` */
  static readonly ProjectsV2ControllerCreatePath = '/v2/projects';

  /**
   * Required permissions: projects:create, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerCreate$Response(
    params: {
      body: WorkCreateProjectDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProject>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProject>;
      })
    );
  }

  /**
   * Required permissions: projects:create, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerCreate(
    params: {
      body: WorkCreateProjectDto
    },
    context?: HttpContext
  ): Observable<WorkProject> {
    return this.projectsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProject>): WorkProject => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerFindAllLagerProjects()` */
  static readonly ProjectsV2ControllerFindAllLagerProjectsPath = '/v2/projects/lager';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerFindAllLagerProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindAllLagerProjects$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProject>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerFindAllLagerProjectsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProject>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerFindAllLagerProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindAllLagerProjects(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkProject>> {
    return this.projectsV2ControllerFindAllLagerProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProject>>): Array<WorkProject> => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerFindProjectsToFollowUp()` */
  static readonly ProjectsV2ControllerFindProjectsToFollowUpPath = '/v2/projects/nachfassen';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerFindProjectsToFollowUp()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindProjectsToFollowUp$Response(
    params?: {
      page?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectNachfassenPaginatedDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerFindProjectsToFollowUpPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectNachfassenPaginatedDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerFindProjectsToFollowUp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindProjectsToFollowUp(
    params?: {
      page?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectNachfassenPaginatedDto> {
    return this.projectsV2ControllerFindProjectsToFollowUp$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectNachfassenPaginatedDto>): WorkProjectNachfassenPaginatedDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerFindProjectsForDatenbereinigung()` */
  static readonly ProjectsV2ControllerFindProjectsForDatenbereinigungPath = '/v2/projects/datenbereinigung';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerFindProjectsForDatenbereinigung()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindProjectsForDatenbereinigung$Response(
    params?: {

    /**
     * Kundenberater (project.userId). Defaults to the logged-in user.
     */
      userId?: number;

    /**
     * When true, lists projects without a Kundenberater (userId IS NULL) and ignores userId.
     */
      withoutKundenberater?: boolean;

    /**
     * When true, lists projects of all Kundenberater (no userId filter). Takes precedence over withoutKundenberater/userId.
     */
      allKundenberater?: boolean;

    /**
     * ISO cutoff date. Defaults to 12 months ago.
     */
      inactiveSince?: string;
      page?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectDatenbereinigungPaginatedDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerFindProjectsForDatenbereinigungPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
      rb.query('withoutKundenberater', params.withoutKundenberater, {});
      rb.query('allKundenberater', params.allKundenberater, {});
      rb.query('inactiveSince', params.inactiveSince, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectDatenbereinigungPaginatedDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerFindProjectsForDatenbereinigung$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindProjectsForDatenbereinigung(
    params?: {

    /**
     * Kundenberater (project.userId). Defaults to the logged-in user.
     */
      userId?: number;

    /**
     * When true, lists projects without a Kundenberater (userId IS NULL) and ignores userId.
     */
      withoutKundenberater?: boolean;

    /**
     * When true, lists projects of all Kundenberater (no userId filter). Takes precedence over withoutKundenberater/userId.
     */
      allKundenberater?: boolean;

    /**
     * ISO cutoff date. Defaults to 12 months ago.
     */
      inactiveSince?: string;
      page?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectDatenbereinigungPaginatedDto> {
    return this.projectsV2ControllerFindProjectsForDatenbereinigung$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectDatenbereinigungPaginatedDto>): WorkProjectDatenbereinigungPaginatedDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerFindProjectsWithoutBuildDate()` */
  static readonly ProjectsV2ControllerFindProjectsWithoutBuildDatePath = '/v2/projects/ohne-gebaut-datum';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerFindProjectsWithoutBuildDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindProjectsWithoutBuildDate$Response(
    params?: {

    /**
     * Projektleiter (project.tpbUserId). Defaults to the logged-in user.
     */
      tpbUserId?: number;

    /**
     * When true, lists projects without a Projektleiter (tpbUserId IS NULL) and ignores tpbUserId.
     */
      withoutProjektleiter?: boolean;

    /**
     * When true, lists projects of all Projektleiter (no tpbUserId filter). Takes precedence.
     */
      allProjektleiter?: boolean;
      page?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectOhneGebautDatumPaginatedDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerFindProjectsWithoutBuildDatePath, 'get');
    if (params) {
      rb.query('tpbUserId', params.tpbUserId, {});
      rb.query('withoutProjektleiter', params.withoutProjektleiter, {});
      rb.query('allProjektleiter', params.allProjektleiter, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectOhneGebautDatumPaginatedDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerFindProjectsWithoutBuildDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindProjectsWithoutBuildDate(
    params?: {

    /**
     * Projektleiter (project.tpbUserId). Defaults to the logged-in user.
     */
      tpbUserId?: number;

    /**
     * When true, lists projects without a Projektleiter (tpbUserId IS NULL) and ignores tpbUserId.
     */
      withoutProjektleiter?: boolean;

    /**
     * When true, lists projects of all Projektleiter (no tpbUserId filter). Takes precedence.
     */
      allProjektleiter?: boolean;
      page?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectOhneGebautDatumPaginatedDto> {
    return this.projectsV2ControllerFindProjectsWithoutBuildDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectOhneGebautDatumPaginatedDto>): WorkProjectOhneGebautDatumPaginatedDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerFindProjectsWithoutCommissioningDate()` */
  static readonly ProjectsV2ControllerFindProjectsWithoutCommissioningDatePath = '/v2/projects/ohne-inbetriebnahme-datum';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerFindProjectsWithoutCommissioningDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindProjectsWithoutCommissioningDate$Response(
    params?: {

    /**
     * Projektleiter (project.tpbUserId). Defaults to the logged-in user.
     */
      tpbUserId?: number;

    /**
     * When true, lists projects without a Projektleiter (tpbUserId IS NULL) and ignores tpbUserId.
     */
      withoutProjektleiter?: boolean;

    /**
     * When true, lists projects of all Projektleiter (no tpbUserId filter). Takes precedence.
     */
      allProjektleiter?: boolean;
      page?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectOhneInbetriebnahmeDatumPaginatedDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerFindProjectsWithoutCommissioningDatePath, 'get');
    if (params) {
      rb.query('tpbUserId', params.tpbUserId, {});
      rb.query('withoutProjektleiter', params.withoutProjektleiter, {});
      rb.query('allProjektleiter', params.allProjektleiter, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectOhneInbetriebnahmeDatumPaginatedDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerFindProjectsWithoutCommissioningDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindProjectsWithoutCommissioningDate(
    params?: {

    /**
     * Projektleiter (project.tpbUserId). Defaults to the logged-in user.
     */
      tpbUserId?: number;

    /**
     * When true, lists projects without a Projektleiter (tpbUserId IS NULL) and ignores tpbUserId.
     */
      withoutProjektleiter?: boolean;

    /**
     * When true, lists projects of all Projektleiter (no tpbUserId filter). Takes precedence.
     */
      allProjektleiter?: boolean;
      page?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectOhneInbetriebnahmeDatumPaginatedDto> {
    return this.projectsV2ControllerFindProjectsWithoutCommissioningDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectOhneInbetriebnahmeDatumPaginatedDto>): WorkProjectOhneInbetriebnahmeDatumPaginatedDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerFindProjectsWithReversedInstallationDates()` */
  static readonly ProjectsV2ControllerFindProjectsWithReversedInstallationDatesPath = '/v2/projects/montagedaten-vertauscht';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerFindProjectsWithReversedInstallationDates()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindProjectsWithReversedInstallationDates$Response(
    params?: {
      page?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectMontagedatenVertauschtPaginatedDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerFindProjectsWithReversedInstallationDatesPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectMontagedatenVertauschtPaginatedDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerFindProjectsWithReversedInstallationDates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindProjectsWithReversedInstallationDates(
    params?: {
      page?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectMontagedatenVertauschtPaginatedDto> {
    return this.projectsV2ControllerFindProjectsWithReversedInstallationDates$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectMontagedatenVertauschtPaginatedDto>): WorkProjectMontagedatenVertauschtPaginatedDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerSwapInstallationDates()` */
  static readonly ProjectsV2ControllerSwapInstallationDatesPath = '/v2/projects/montagedaten-vertauschen/{projectId}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerSwapInstallationDates()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerSwapInstallationDates$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerSwapInstallationDatesPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerSwapInstallationDates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerSwapInstallationDates(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.projectsV2ControllerSwapInstallationDates$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerFindAllForCalculationItemMove()` */
  static readonly ProjectsV2ControllerFindAllForCalculationItemMovePath = '/v2/projects/findAllForCalculationItemMove/{itemId}/{sourceCalculationId}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerFindAllForCalculationItemMove()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindAllForCalculationItemMove$Response(
    params: {
      itemId: number;
      sourceCalculationId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProject>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerFindAllForCalculationItemMovePath, 'get');
    if (params) {
      rb.path('itemId', params.itemId, {});
      rb.path('sourceCalculationId', params.sourceCalculationId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProject>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerFindAllForCalculationItemMove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindAllForCalculationItemMove(
    params: {
      itemId: number;
      sourceCalculationId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkProject>> {
    return this.projectsV2ControllerFindAllForCalculationItemMove$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProject>>): Array<WorkProject> => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerFindAllInPlanningForContactAndContainertype()` */
  static readonly ProjectsV2ControllerFindAllInPlanningForContactAndContainertypePath = '/v2/projects/findAllInPlanningForContactAndContainertype/{contactId}/{containertypeId}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerFindAllInPlanningForContactAndContainertype()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindAllInPlanningForContactAndContainertype$Response(
    params: {
      contactId: number;
      containertypeId: number;
      currentProjectIdToExclude?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProject>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerFindAllInPlanningForContactAndContainertypePath, 'get');
    if (params) {
      rb.path('contactId', params.contactId, {});
      rb.path('containertypeId', params.containertypeId, {});
      rb.query('currentProjectIdToExclude', params.currentProjectIdToExclude, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProject>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerFindAllInPlanningForContactAndContainertype$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindAllInPlanningForContactAndContainertype(
    params: {
      contactId: number;
      containertypeId: number;
      currentProjectIdToExclude?: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkProject>> {
    return this.projectsV2ControllerFindAllInPlanningForContactAndContainertype$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProject>>): Array<WorkProject> => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerFindAllWithFiltersForMap()` */
  static readonly ProjectsV2ControllerFindAllWithFiltersForMapPath = '/v2/projects/findAllWithFiltersForMap';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerFindAllWithFiltersForMap()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindAllWithFiltersForMap$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 10000
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 10000
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by container.containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.container.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.container.containertypeId=$not:$like:John Doe&filter.container.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.container.containertypeId'?: Array<string>;

    /**
     * Filter by contact.canton query param.
     *           <p>
     *              <b>Format: </b> filter.contact.canton={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.contact.canton=$not:$like:John Doe&filter.contact.canton=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.contact.canton'?: Array<string>;

    /**
     * Filter by contact.businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.contact.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.contact.businessunitId=$not:$like:John Doe&filter.contact.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.contact.businessunitId'?: Array<string>;

    /**
     * Filter by statusId query param.
     *           <p>
     *              <b>Format: </b> filter.statusId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.statusId=$not:$like:John Doe&filter.statusId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.statusId'?: Array<string>;

    /**
     * Filter by latitude query param.
     *           <p>
     *              <b>Format: </b> filter.latitude={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.latitude=$not:$like:John Doe&filter.latitude=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.latitude'?: Array<string>;

    /**
     * Filter by longitude query param.
     *           <p>
     *              <b>Format: </b> filter.longitude={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.longitude=$not:$like:John Doe&filter.longitude=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.longitude'?: Array<string>;

    /**
     * Filter by installationStart query param.
     *           <p>
     *              <b>Format: </b> filter.installationStart={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.installationStart=$not:$like:John Doe&filter.installationStart=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$lte</li></ul>
     */
      'filter.installationStart'?: Array<string>;

    /**
     * Filter by installationEnd query param.
     *           <p>
     *              <b>Format: </b> filter.installationEnd={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.installationEnd=$not:$like:John Doe&filter.installationEnd=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li></ul>
     */
      'filter.installationEnd'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>numberQualified</li>
     * <li>statusId</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'numberQualified:ASC' | 'numberQualified:DESC' | 'statusId:ASC' | 'statusId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> 
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProjectMapDto>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'container.containertypeId'?: (string | Array<string>);
'contact.canton'?: (string | Array<string>);
'contact.businessunitId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
'latitude'?: (string | Array<string>);
'longitude'?: (string | Array<string>);
'installationStart'?: (string | Array<string>);
'installationEnd'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerFindAllWithFiltersForMapPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.container.containertypeId', params['filter.container.containertypeId'], {});
      rb.query('filter.contact.canton', params['filter.contact.canton'], {});
      rb.query('filter.contact.businessunitId', params['filter.contact.businessunitId'], {});
      rb.query('filter.statusId', params['filter.statusId'], {});
      rb.query('filter.latitude', params['filter.latitude'], {});
      rb.query('filter.longitude', params['filter.longitude'], {});
      rb.query('filter.installationStart', params['filter.installationStart'], {});
      rb.query('filter.installationEnd', params['filter.installationEnd'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkProjectMapDto>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'container.containertypeId'?: (string | Array<string>);
        'contact.canton'?: (string | Array<string>);
        'contact.businessunitId'?: (string | Array<string>);
        'statusId'?: (string | Array<string>);
        'latitude'?: (string | Array<string>);
        'longitude'?: (string | Array<string>);
        'installationStart'?: (string | Array<string>);
        'installationEnd'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerFindAllWithFiltersForMap$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindAllWithFiltersForMap(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 10000
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 10000
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by container.containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.container.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.container.containertypeId=$not:$like:John Doe&filter.container.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.container.containertypeId'?: Array<string>;

    /**
     * Filter by contact.canton query param.
     *           <p>
     *              <b>Format: </b> filter.contact.canton={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.contact.canton=$not:$like:John Doe&filter.contact.canton=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.contact.canton'?: Array<string>;

    /**
     * Filter by contact.businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.contact.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.contact.businessunitId=$not:$like:John Doe&filter.contact.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.contact.businessunitId'?: Array<string>;

    /**
     * Filter by statusId query param.
     *           <p>
     *              <b>Format: </b> filter.statusId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.statusId=$not:$like:John Doe&filter.statusId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.statusId'?: Array<string>;

    /**
     * Filter by latitude query param.
     *           <p>
     *              <b>Format: </b> filter.latitude={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.latitude=$not:$like:John Doe&filter.latitude=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.latitude'?: Array<string>;

    /**
     * Filter by longitude query param.
     *           <p>
     *              <b>Format: </b> filter.longitude={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.longitude=$not:$like:John Doe&filter.longitude=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.longitude'?: Array<string>;

    /**
     * Filter by installationStart query param.
     *           <p>
     *              <b>Format: </b> filter.installationStart={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.installationStart=$not:$like:John Doe&filter.installationStart=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$lte</li></ul>
     */
      'filter.installationStart'?: Array<string>;

    /**
     * Filter by installationEnd query param.
     *           <p>
     *              <b>Format: </b> filter.installationEnd={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.installationEnd=$not:$like:John Doe&filter.installationEnd=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li></ul>
     */
      'filter.installationEnd'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>numberQualified</li>
     * <li>statusId</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'numberQualified:ASC' | 'numberQualified:DESC' | 'statusId:ASC' | 'statusId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> 
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkProjectMapDto>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'container.containertypeId'?: (string | Array<string>);
'contact.canton'?: (string | Array<string>);
'contact.businessunitId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
'latitude'?: (string | Array<string>);
'longitude'?: (string | Array<string>);
'installationStart'?: (string | Array<string>);
'installationEnd'?: (string | Array<string>);
};
};
}> {
    return this.projectsV2ControllerFindAllWithFiltersForMap$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProjectMapDto>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'container.containertypeId'?: (string | Array<string>);
'contact.canton'?: (string | Array<string>);
'contact.businessunitId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
'latitude'?: (string | Array<string>);
'longitude'?: (string | Array<string>);
'installationStart'?: (string | Array<string>);
'installationEnd'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkProjectMapDto>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'container.containertypeId'?: (string | Array<string>);
'contact.canton'?: (string | Array<string>);
'contact.businessunitId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
'latitude'?: (string | Array<string>);
'longitude'?: (string | Array<string>);
'installationStart'?: (string | Array<string>);
'installationEnd'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerGetProjectAnalysis()` */
  static readonly ProjectsV2ControllerGetProjectAnalysisPath = '/v2/projects/projectAnalysis/{analysisSource}/{id}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerGetProjectAnalysis()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerGetProjectAnalysis$Response(
    params: {
      analysisSource: WorkProjectAnalysisSourceEnum;
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectAnalysisDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerGetProjectAnalysisPath, 'get');
    if (params) {
      rb.path('analysisSource', params.analysisSource, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectAnalysisDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerGetProjectAnalysis$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerGetProjectAnalysis(
    params: {
      analysisSource: WorkProjectAnalysisSourceEnum;
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectAnalysisDto> {
    return this.projectsV2ControllerGetProjectAnalysis$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectAnalysisDto>): WorkProjectAnalysisDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerGetStatistics()` */
  static readonly ProjectsV2ControllerGetStatisticsPath = '/v2/projects/statistics';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerGetStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerGetStatistics$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectStatisticsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerGetStatisticsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectStatisticsDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerGetStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerGetStatistics(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkProjectStatisticsDto> {
    return this.projectsV2ControllerGetStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectStatisticsDto>): WorkProjectStatisticsDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerFindPlanningModeCandidates()` */
  static readonly ProjectsV2ControllerFindPlanningModeCandidatesPath = '/v2/projects/planning-mode-candidates';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerFindPlanningModeCandidates()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindPlanningModeCandidates$Response(
    params?: {
      contactId?: number;
      projectId?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectPlanningModeCandidatesDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerFindPlanningModeCandidatesPath, 'get');
    if (params) {
      rb.query('contactId', params.contactId, {});
      rb.query('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectPlanningModeCandidatesDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerFindPlanningModeCandidates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindPlanningModeCandidates(
    params?: {
      contactId?: number;
      projectId?: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectPlanningModeCandidatesDto> {
    return this.projectsV2ControllerFindPlanningModeCandidates$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectPlanningModeCandidatesDto>): WorkProjectPlanningModeCandidatesDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerFindOneById()` */
  static readonly ProjectsV2ControllerFindOneByIdPath = '/v2/projects/{id}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindOneById$Response(
    params: {
      id: number;
      withAllDetails?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProject>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('withAllDetails', params.withAllDetails, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProject>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerFindOneById(
    params: {
      id: number;
      withAllDetails?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkProject> {
    return this.projectsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProject>): WorkProject => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerUpdate()` */
  static readonly ProjectsV2ControllerUpdatePath = '/v2/projects/{id}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateProjectDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProject>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProject>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateProjectDto
    },
    context?: HttpContext
  ): Observable<WorkProject> {
    return this.projectsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProject>): WorkProject => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerGetPowerWrAc()` */
  static readonly ProjectsV2ControllerGetPowerWrAcPath = '/v2/projects/powerWrAc/{id}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerGetPowerWrAc()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerGetPowerWrAc$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectPowerWrAcDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerGetPowerWrAcPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectPowerWrAcDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerGetPowerWrAc$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerGetPowerWrAc(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectPowerWrAcDto> {
    return this.projectsV2ControllerGetPowerWrAc$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectPowerWrAcDto>): WorkProjectPowerWrAcDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerGetCommunitySponsorshipLocation()` */
  static readonly ProjectsV2ControllerGetCommunitySponsorshipLocationPath = '/v2/projects/communitySponsorshipLocation/{id}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerGetCommunitySponsorshipLocation()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerGetCommunitySponsorshipLocation$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkLocation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerGetCommunitySponsorshipLocationPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkLocation>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerGetCommunitySponsorshipLocation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerGetCommunitySponsorshipLocation(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkLocation> {
    return this.projectsV2ControllerGetCommunitySponsorshipLocation$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkLocation>): WorkLocation => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerGetFoerderungUsedCalculationitems()` */
  static readonly ProjectsV2ControllerGetFoerderungUsedCalculationitemsPath = '/v2/projects/foerderungUsedCalculationitems/{id}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerGetFoerderungUsedCalculationitems()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerGetFoerderungUsedCalculationitems$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectFoerderungUsedItemsWithAmountDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerGetFoerderungUsedCalculationitemsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectFoerderungUsedItemsWithAmountDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerGetFoerderungUsedCalculationitems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerGetFoerderungUsedCalculationitems(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectFoerderungUsedItemsWithAmountDto> {
    return this.projectsV2ControllerGetFoerderungUsedCalculationitems$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectFoerderungUsedItemsWithAmountDto>): WorkProjectFoerderungUsedItemsWithAmountDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerGetFoerderungEivCalculations()` */
  static readonly ProjectsV2ControllerGetFoerderungEivCalculationsPath = '/v2/projects/foerderungEivCalculations/{id}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerGetFoerderungEivCalculations()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerGetFoerderungEivCalculations$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEivCalculationsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerGetFoerderungEivCalculationsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEivCalculationsDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerGetFoerderungEivCalculations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerGetFoerderungEivCalculations(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEivCalculationsDto> {
    return this.projectsV2ControllerGetFoerderungEivCalculations$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEivCalculationsDto>): WorkEivCalculationsDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerGetProjectAndContactFromAddressFuzzy()` */
  static readonly ProjectsV2ControllerGetProjectAndContactFromAddressFuzzyPath = '/v2/projects/getProjectAndContactFromAddressFuzzy';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerGetProjectAndContactFromAddressFuzzy()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerGetProjectAndContactFromAddressFuzzy$Response(
    params: {
      body: WorkAddressDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProject>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerGetProjectAndContactFromAddressFuzzyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProject>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerGetProjectAndContactFromAddressFuzzy$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerGetProjectAndContactFromAddressFuzzy(
    params: {
      body: WorkAddressDto
    },
    context?: HttpContext
  ): Observable<Array<WorkProject>> {
    return this.projectsV2ControllerGetProjectAndContactFromAddressFuzzy$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProject>>): Array<WorkProject> => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerGetCoordinatesFromAddress()` */
  static readonly ProjectsV2ControllerGetCoordinatesFromAddressPath = '/v2/projects/get-coordinates-from-address';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerGetCoordinatesFromAddress()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerGetCoordinatesFromAddress$Response(
    params: {
      body: WorkAddressDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCoordinatesDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerGetCoordinatesFromAddressPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCoordinatesDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerGetCoordinatesFromAddress$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerGetCoordinatesFromAddress(
    params: {
      body: WorkAddressDto
    },
    context?: HttpContext
  ): Observable<WorkCoordinatesDto> {
    return this.projectsV2ControllerGetCoordinatesFromAddress$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCoordinatesDto>): WorkCoordinatesDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerChangePriceOffered()` */
  static readonly ProjectsV2ControllerChangePriceOfferedPath = '/v2/projects/changePriceOffered/{id}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerChangePriceOffered()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerChangePriceOffered$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProject>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerChangePriceOfferedPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProject>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerChangePriceOffered$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerChangePriceOffered(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkProject> {
    return this.projectsV2ControllerChangePriceOffered$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProject>): WorkProject => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerStartPlanning()` */
  static readonly ProjectsV2ControllerStartPlanningPath = '/v2/projects/start-planning/{projectId}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerStartPlanning()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerStartPlanning$Response(
    params: {
      projectId: number;
      body: WorkStartProjectPlanningDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProject>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerStartPlanningPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProject>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerStartPlanning$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerStartPlanning(
    params: {
      projectId: number;
      body: WorkStartProjectPlanningDto
    },
    context?: HttpContext
  ): Observable<WorkProject> {
    return this.projectsV2ControllerStartPlanning$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProject>): WorkProject => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerUpdateNotes()` */
  static readonly ProjectsV2ControllerUpdateNotesPath = '/v2/projects/notes/{id}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerUpdateNotes()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerUpdateNotes$Response(
    params: {
      id: number;
      body: WorkUpdateProjectNotesDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProject>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerUpdateNotesPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProject>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerUpdateNotes$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerUpdateNotes(
    params: {
      id: number;
      body: WorkUpdateProjectNotesDto
    },
    context?: HttpContext
  ): Observable<WorkProject> {
    return this.projectsV2ControllerUpdateNotes$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProject>): WorkProject => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerCloseProject()` */
  static readonly ProjectsV2ControllerCloseProjectPath = '/v2/projects/close/{projectId}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerCloseProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerCloseProject$Response(
    params: {
      projectId: number;
      reasontypeId?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerCloseProjectPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.query('reasontypeId', params.reasontypeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerCloseProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerCloseProject(
    params: {
      projectId: number;
      reasontypeId?: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.projectsV2ControllerCloseProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerReactivateProject()` */
  static readonly ProjectsV2ControllerReactivateProjectPath = '/v2/projects/reactivate/{projectId}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerReactivateProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerReactivateProject$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerReactivateProjectPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerReactivateProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerReactivateProject(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.projectsV2ControllerReactivateProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerLockProject()` */
  static readonly ProjectsV2ControllerLockProjectPath = '/v2/projects/lock/{projectId}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerLockProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerLockProject$Response(
    params: {
      projectId: number;
      lockedNotes: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerLockProjectPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.query('lockedNotes', params.lockedNotes, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerLockProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerLockProject(
    params: {
      projectId: number;
      lockedNotes: string;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.projectsV2ControllerLockProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerUnlockProject()` */
  static readonly ProjectsV2ControllerUnlockProjectPath = '/v2/projects/unlock/{projectId}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerUnlockProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerUnlockProject$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerUnlockProjectPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerUnlockProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerUnlockProject(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.projectsV2ControllerUnlockProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerUpdateCoordinates()` */
  static readonly ProjectsV2ControllerUpdateCoordinatesPath = '/v2/projects/update-coordinates/{id}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerUpdateCoordinates()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerUpdateCoordinates$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerUpdateCoordinatesPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerUpdateCoordinates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerUpdateCoordinates(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.projectsV2ControllerUpdateCoordinates$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerSetProjectToSold()` */
  static readonly ProjectsV2ControllerSetProjectToSoldPath = '/v2/projects/setProjectToSold/{projectId}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerSetProjectToSold()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerSetProjectToSold$Response(
    params: {
      projectId: number;
      body: WorkSetProjectToSoldDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerSetProjectToSoldPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerSetProjectToSold$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerSetProjectToSold(
    params: {
      projectId: number;
      body: WorkSetProjectToSoldDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.projectsV2ControllerSetProjectToSold$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerSetProjectToPlanned()` */
  static readonly ProjectsV2ControllerSetProjectToPlannedPath = '/v2/projects/setProjectToPlanned/{projectId}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerSetProjectToPlanned()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerSetProjectToPlanned$Response(
    params: {
      projectId: number;
      body: WorkSetProjectToPlannedDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProject>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerSetProjectToPlannedPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProject>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerSetProjectToPlanned$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerSetProjectToPlanned(
    params: {
      projectId: number;
      body: WorkSetProjectToPlannedDto
    },
    context?: HttpContext
  ): Observable<WorkProject> {
    return this.projectsV2ControllerSetProjectToPlanned$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProject>): WorkProject => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerLinkProject()` */
  static readonly ProjectsV2ControllerLinkProjectPath = '/v2/projects/linkProject/{projectId}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerLinkProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerLinkProject$Response(
    params: {
      projectId: number;
      body: WorkLinkProjectDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProject>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerLinkProjectPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProject>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerLinkProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerLinkProject(
    params: {
      projectId: number;
      body: WorkLinkProjectDto
    },
    context?: HttpContext
  ): Observable<WorkProject> {
    return this.projectsV2ControllerLinkProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProject>): WorkProject => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerGetStornoPreview()` */
  static readonly ProjectsV2ControllerGetStornoPreviewPath = '/v2/projects/stornoPreview/{projectId}';

  /**
   * Required permissions: projects:storno
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerGetStornoPreview()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerGetStornoPreview$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectStornoPreviewDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerGetStornoPreviewPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectStornoPreviewDto>;
      })
    );
  }

  /**
   * Required permissions: projects:storno
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerGetStornoPreview$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerGetStornoPreview(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectStornoPreviewDto> {
    return this.projectsV2ControllerGetStornoPreview$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectStornoPreviewDto>): WorkProjectStornoPreviewDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerStornoProject()` */
  static readonly ProjectsV2ControllerStornoProjectPath = '/v2/projects/setProjectToStorno/{projectId}';

  /**
   * Required permissions: projects:storno
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerStornoProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerStornoProject$Response(
    params: {
      projectId: number;
      body: WorkSetProjectToStornoDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectStornoResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerStornoProjectPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectStornoResultDto>;
      })
    );
  }

  /**
   * Required permissions: projects:storno
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerStornoProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerStornoProject(
    params: {
      projectId: number;
      body: WorkSetProjectToStornoDto
    },
    context?: HttpContext
  ): Observable<WorkProjectStornoResultDto> {
    return this.projectsV2ControllerStornoProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectStornoResultDto>): WorkProjectStornoResultDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerStornoProjectForOfficeV4()` */
  static readonly ProjectsV2ControllerStornoProjectForOfficeV4Path = '/v2/projects/setProjectToStorno/v4';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerStornoProjectForOfficeV4()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerStornoProjectForOfficeV4$Response(
    params: {
      body: WorkSetProjectToStornoV4Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectStornoResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerStornoProjectForOfficeV4Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectStornoResultDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerStornoProjectForOfficeV4$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerStornoProjectForOfficeV4(
    params: {
      body: WorkSetProjectToStornoV4Dto
    },
    context?: HttpContext
  ): Observable<WorkProjectStornoResultDto> {
    return this.projectsV2ControllerStornoProjectForOfficeV4$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectStornoResultDto>): WorkProjectStornoResultDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerUnlinkProject()` */
  static readonly ProjectsV2ControllerUnlinkProjectPath = '/v2/projects/unlinkProject/{projectId}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerUnlinkProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerUnlinkProject$Response(
    params: {
      projectId: number;
      body: WorkUnlinkProjectDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProject>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerUnlinkProjectPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProject>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerUnlinkProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerUnlinkProject(
    params: {
      projectId: number;
      body: WorkUnlinkProjectDto
    },
    context?: HttpContext
  ): Observable<WorkProject> {
    return this.projectsV2ControllerUnlinkProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProject>): WorkProject => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerCalculateModulesArea()` */
  static readonly ProjectsV2ControllerCalculateModulesAreaPath = '/v2/projects/modulesArea/{id}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerCalculateModulesArea()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerCalculateModulesArea$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectModulesAreaDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerCalculateModulesAreaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectModulesAreaDto>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerCalculateModulesArea$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV2ControllerCalculateModulesArea(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectModulesAreaDto> {
    return this.projectsV2ControllerCalculateModulesArea$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectModulesAreaDto>): WorkProjectModulesAreaDto => r.body)
    );
  }

  /** Path part for operation `projectsV2ControllerUpdateAnlageUndObjektDaten()` */
  static readonly ProjectsV2ControllerUpdateAnlageUndObjektDatenPath = '/v2/projects/anlageDaten/{id}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV2ControllerUpdateAnlageUndObjektDaten()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerUpdateAnlageUndObjektDaten$Response(
    params: {
      id: number;
      body: WorkUpdateProjectAnlageUndObjektdatenDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProject>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsV2Service.ProjectsV2ControllerUpdateAnlageUndObjektDatenPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProject>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV2ControllerUpdateAnlageUndObjektDaten$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsV2ControllerUpdateAnlageUndObjektDaten(
    params: {
      id: number;
      body: WorkUpdateProjectAnlageUndObjektdatenDto
    },
    context?: HttpContext
  ): Observable<WorkProject> {
    return this.projectsV2ControllerUpdateAnlageUndObjektDaten$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProject>): WorkProject => r.body)
    );
  }

}
